// src/utils/cedulasFiscales.js

export const CEDULAS = {
  TRABAJO: 'trabajo',
  CAPITAL: 'capital',
  NO_LABORAL: 'no_laboral',
  PENSIONES: 'pensiones',
  DIVIDENDOS: 'dividendos',
  GANANCIA_OCASIONAL: 'ganancia_ocasional',
  NO_CLASIFICADO: 'no_clasificado',
}

export const CATEGORIA_A_CEDULA = {
  'Salario': CEDULAS.TRABAJO,
  'Horas extra': CEDULAS.TRABAJO,
  'Bonificaciones': CEDULAS.TRABAJO,
  'Primas': CEDULAS.TRABAJO,
  'Cesantías': CEDULAS.TRABAJO,
  'Comisiones': CEDULAS.TRABAJO,
  'Honorarios': CEDULAS.NO_LABORAL,
  'Negocio propio': CEDULAS.NO_LABORAL,
  'Regalos o ayudas familiares': CEDULAS.NO_CLASIFICADO,
  'Otro': CEDULAS.NO_CLASIFICADO,
}

export function getCedula(categoria) {
  if (!categoria) return CEDULAS.NO_CLASIFICADO
  return CATEGORIA_A_CEDULA[categoria] || CEDULAS.NO_CLASIFICADO
}

export const CEDULA_LABELS = {
  [CEDULAS.TRABAJO]: 'declaracion_cedula_trabajo',
  [CEDULAS.CAPITAL]: 'declaracion_cedula_capital',
  [CEDULAS.NO_LABORAL]: 'declaracion_cedula_no_laboral',
  [CEDULAS.PENSIONES]: 'declaracion_cedula_pensiones',
  [CEDULAS.DIVIDENDOS]: 'declaracion_cedula_dividendos',
  [CEDULAS.GANANCIA_OCASIONAL]: 'declaracion_cedula_ganancia_ocasional',
  [CEDULAS.NO_CLASIFICADO]: 'declaracion_cedula_no_clasificado',
}

// ============================================================
// NUEVO: Cédulas del Formulario 210 (wizard de Declaración de Renta)
// Independiente de las cédulas usadas para clasificar transacciones arriba.
// ============================================================

export const CEDULAS_F210 = {
  TRABAJO: 'trabajo',
  HONORARIOS: 'honorarios',
  CAPITAL: 'capital',
  NO_LABORAL: 'no_laboral',
  PENSIONES: 'pensiones',
}

// disponible: true = ya tiene preguntas implementadas en el wizard.
// Las demás se muestran como "Próximamente" hasta que agreguemos sus preguntas.
export const CEDULAS_F210_INFO = [
  {
    id: CEDULAS_F210.TRABAJO,
    label: 'Rentas de Trabajo',
    descripcion: 'Salarios, horas extra, bonificaciones, primas, cesantías y comisiones de una relación laboral.',
    disponible: true,
  },
  {
    id: CEDULAS_F210.HONORARIOS,
    label: 'Honorarios',
    descripcion: 'Ingresos por prestación de servicios de forma independiente (rentas de trabajo que no provienen de una relación laboral).',
    disponible: true,
  },
  {
    id: CEDULAS_F210.CAPITAL,
    label: 'Rentas de Capital',
    descripcion: 'Arrendamientos, intereses, rendimientos financieros, regalías.',
    disponible: true,
  },
  {
    id: CEDULAS_F210.NO_LABORAL,
    label: 'Rentas No Laborales',
    descripcion: 'Ingresos de negocio propio, establecimientos de comercio y otras actividades no laborales.',
    disponible: true,
  },
  {
    id: CEDULAS_F210.PENSIONES,
    label: 'Pensiones',
    descripcion: 'Ingresos por mesadas pensionales.',
    disponible: true,
  },
]

export function obtenerInfoCedulaF210(id) {
  return CEDULAS_F210_INFO.find(c => c.id === id)
}